import {Component, Vue} from 'vue-property-decorator';
import OrderList from './order-list/order-list.vue';

@Component({
  components: {OrderList},
})
export default class OrderMain extends Vue {
  public listStatusObj: any = {
    orderNo: '',                                                        // 订单号
    pageIndex: 1,                                                       // 页码
    orderStatus: '',                                                    // 订单状态
    checkoutOrderDateType: 3,                                           // 下单日期类型 1最近一天  2最近一周  3最近一个月  4最近三个月  5最近6个月  6当年  7去年 8前年 9大前年  10大前年之前
    orderDelete: 0,                                                     // 订单删除标志 0：未删除 1：已删除
    orderTabSwitch: 1,                                                  // 1所有 2待付款 5待签收
  };
  public insertedOrderNo: string = '';                                  //  用户实际输入的订单号
  public allChecked: boolean = false;                                   //  全选标志
  public orderList: object = {};                                        //  订单列表
  public thisYear = new Date(this._common.getNowTime()).getFullYear();  //  参考年份(今年)
  public orderDateList = ['最近一天', '最近一周', '最近一月', '最近三月', '最近六月',
                            this.thisYear, this.thisYear - 1, this.thisYear - 2, this.thisYear - 3, this.thisYear - 3 + '以前'];
  public statusNum = {};
  public isOpenScanCodeSigning: boolean = false;                       //  扫码签收弹框开关
  public packageCode: string = '';
  public isLoading: boolean = true;
  public isScanErr: boolean = false;                                   //  扫码签收未输入码

  //  tab切换并获得当前tab下标
  public changeTab(value: number) {
    this.listStatusObj.orderTabSwitch = value;
    this.listStatusObj.orderDelete = 0;
    this.allChecked = false;
    this.listStatusObj.pageIndex = 1;
  }

  //  关键字模糊查询
  public keyWordSearch() {
    this.listStatusObj.orderNo = this.insertedOrderNo;
    this.listStatusObj.pageIndex = 1;
  }

  //  父组件监听子组件的页码改变
  public pageChange(page: any) {
    this.listStatusObj.pageIndex = page;
  }

  //  获得待付款/代签收的数量
  public getOrderStatusNum(statusNum: any) {
    this.statusNum = statusNum;
  }

  //  切换订单回收站
  public collection() {
    this.listStatusObj.orderDelete = 1;
    this.listStatusObj.orderTabSwitch = 0;
  }

  //  关闭扫码签收
  public closeScan() {
    this.isScanErr = false;
    this.isOpenScanCodeSigning = false;
    this.packageCode = '';
  }

  //  确认扫码签收
  public confirmScan() {
    if (this.packageCode) {
      this.fetch({
        url: window.apis.scanCode,
        data: {
          packageNo: this.packageCode
        }
      }).then(() => {
        this.closeScan()
      })
    } else {
      this.isScanErr = true;
    }
  }

  //  子组件(订单列表数据是否更新)
  public loaded(isLoaded: boolean){
    this.isLoading = !isLoaded;
  }
}
